import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

import { computed } from "vue";
import { ENABLED_FEATURES } from "@/util";
import {
  membersStore,
  projectStore,
  sessionStore,
  stompApiStore,
} from "@/hooks";
import { FlexBox, IconButton, Typography } from "@/components/common";


/**
 * Displays members viewing the current project.
 */
const __default__ = {
  name: "MembersBar",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const connected = computed(
  () => stompApiStore.isConnected || !projectStore.isProjectDefined
);

const members = computed(() => membersStore.activeMembers);

const otherMembers = computed(() =>
  members.value
    .filter((m) => m.email !== sessionStore.userEmail)
    .map(({ email }, idx) => {
      return {
        tooltip: `${email} currently active`,
        firstLetter: email[0].toUpperCase(),
        color: `nodeGradient${(idx % 5) + 1}`,
      };
    })
);

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (_unref(ENABLED_FEATURES).ACTIVE_USERS)
    ? (_openBlock(), _createBlock(_unref(FlexBox), {
        key: 0,
        l: "2"
      }, {
        default: _withCtx(() => [
          (!connected.value)
            ? (_openBlock(), _createBlock(_unref(IconButton), {
                key: 0,
                class: "q-ml-md",
                color: "negative",
                icon: "disconnected",
                tooltip: "Disconnected. Click to reconnect.",
                onClick: _unref(stompApiStore).reconnect
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherMembers.value, (member) => {
              return (_openBlock(), _createBlock(_component_q_avatar, {
                key: member.tooltip,
                color: member.color,
                size: "32px",
                style: {"margin-right":"-6px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Typography), {
                    value: member.firstLetter,
                    variant: "subtitle"
                  }, null, 8, ["value"]),
                  _createVNode(_component_q_tooltip, { self: "center middle" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(member.tooltip), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["color"]))
            }), 128))
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})